// Role home. The shell chrome is already chosen by RoleAwareShell; this picks
// the matching home body for the active role context.

import { createFileRoute } from '@tanstack/react-router';

import { KidHome } from '~/components/home/KidHome';
import { ParentHome } from '~/components/home/ParentHome';
import { SchoolAdminHome } from '~/components/home/SchoolAdminHome';
import { TeacherHome } from '~/components/home/TeacherHome';
import { useAuth } from '~/lib/auth';
import { shellForContext } from '~/lib/roles';

export const Route = createFileRoute('/$locale/')({
  component: RoleHome,
});

function RoleHome() {
  const { currentRoleContext } = useAuth();
  switch (shellForContext(currentRoleContext)) {
    case 'kid':
      return <KidHome />;
    case 'teacher':
      return <TeacherHome />;
    case 'school_admin':
      return <SchoolAdminHome />;
    case 'parent':
    default:
      return <ParentHome />;
  }
}
